import React from "react"
import clsx from "clsx"
import { Alert, Slide, Snackbar } from '@mui/material'

import { APP_SNACKBAR_VARIANT, AppSnackbarProps } from "./AppSnackbarProps"
import AppIcon from '../../atoms/AppIcon/AppIcon'


import { ReactComponent as CloseIcon } from '../../../icons/svg/close2-icon.svg'
import './AppSnackbar.scss'



const SnackbarSlideTransition = (props: any) => {
    return <Slide {...props} direction="up" />
}


export const AppSnackbar = (props: AppSnackbarProps) => {
    const { open, message, variant = APP_SNACKBAR_VARIANT.INFO, duration, className, onClose } = props;

    return (
        <Snackbar
            open={open}
            autoHideDuration={duration}
            TransitionComponent={SnackbarSlideTransition}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            onClose={(event, reason) => {
                if (reason === "clickaway") {
                    return
                }
                onClose?.()
            }}
        >
            <Alert
                onClose={onClose} severity={variant} variant="filled"
                classes={{ root: clsx('app-snackbar-root', `app-snackbar-root--${variant.toLowerCase()}`), action: 'app-snackbar-action' }}
                action={<AppIcon icon={CloseIcon} decorative onClick={onClose} color="var(--color-accent-orange-500)" />}
            >
                {message}
            </Alert>
        </Snackbar>
    )
}